export interface ServiceArea {
  id: string
  name: string
  /** Anchor used today. Swap to `plannedPath` once the city landing page exists. */
  href: string
  /** Reserved slug for the future city landing page. */
  plannedPath: string
}

export const serviceAreas: ServiceArea[] = [
  {
    id: 'northwest-houston',
    name: 'Northwest Houston',
    href: '#contact',
    plannedPath: '/home-remodeling-northwest-houston-tx',
  },
  {
    id: 'cypress',
    name: 'Cypress, TX',
    href: '#contact',
    plannedPath: '/roofing-contractor-cypress-tx',
  },
  {
    id: 'spring',
    name: 'Spring, TX',
    href: '#contact',
    plannedPath: '/home-remodeling-spring-tx',
  },
  {
    id: 'tomball',
    name: 'Tomball, TX',
    href: '#contact',
    plannedPath: '/roofing-tomball-tx',
  },
  {
    id: 'katy',
    name: 'Katy, TX',
    href: '#contact',
    plannedPath: '/kitchen-remodeling-katy-tx',
  },
  {
    id: 'the-woodlands',
    name: 'The Woodlands, TX',
    href: '#contact',
    plannedPath: '/home-remodeling-the-woodlands-tx',
  },
]
